import { authApi, PublicUserProfile } from '@app/services'
import {
  useAuthAvoidUserMutation,
  useAuthGetAvoidedUsersQuery,
  useAuthUnavoidUserMutation,
} from '@app/services/auto-generated/auth'
import { Button } from '@common/components'
import { useAppDispatch } from '@common/hooks'
import { useUser } from '@features/auth/hooks'
import AvoidLimitUpgradeModal from '@features/payment/components/avoid-limit-upgrade-modal/avoid-limit-upgrade-modal'
import { useTheme } from '@features/theme/theme.hooks'
import { useState } from 'react'

const AvoidUser = (props: { userAvoid: PublicUserProfile }) => {
  const { isDark } = useTheme()
  const { userAvoid } = props
  const { user: userAuth } = useUser()
  const dispatch = useAppDispatch()
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)

  const [avoid] = useAuthAvoidUserMutation()
  const [unAvoid] = useAuthUnavoidUserMutation()
  const { data: listAvoided, isLoading } = useAuthGetAvoidedUsersQuery(
    { userId: userAuth?.id as number },
    {
      skip: !userAvoid?.id,
    },
  )

  const handleAvoid = async () => {
    if (userAvoid) {
      const patchResult = dispatch(
        authApi.util.updateQueryData(
          'authGetAvoidedUsers',
          { userId: userAuth?.id as number },
          (draft) => {
            if (draft?.some((user) => user.id === userAvoid?.id)) {
              return (draft = draft?.filter((user) => user.id !== userAvoid?.id))
            } else draft = draft?.push(userAvoid)
          },
        ),
      )
      try {
        if (listAvoided?.some((user) => user.id === userAvoid?.id)) {
          await unAvoid({ userId: userAvoid?.id as number }).unwrap()
        } else {
          await avoid({ userId: userAvoid?.id as number }).unwrap()
        }
      } catch (error: any) {
        patchResult.undo()
        // Check for avoid limit error
        if (error?.data?.detail?.error_code === 'EXC_AVOID_LIMIT_REACHED') {
          setShowUpgradeModal(true)
        }
        console.log(error)
      }
    }
  }

  return (
    <>
      <Button
        disabled={isLoading}
        color={listAvoided?.some((user) => user.id === userAvoid?.id) ? 'neutral' : 'error'}
        variant='outlined'
        onClick={handleAvoid}
        sx={{
          minWidth: '120px',
          borderRadius: '15px',
          fontWeight: '600',
          borderColor: listAvoided?.some((user) => user.id === userAvoid?.id)
            ? isDark
              ? 'white'
              : '#2323'
            : 'error',
          color: listAvoided?.some((user) => user.id === userAvoid?.id)
            ? isDark
              ? 'white'
              : 'black'
            : 'error',
        }}
      >
        {listAvoided?.some((user) => user.id === userAvoid?.id) ? (
          <>UnAvoid</>
        ) : (
          <>Avoid if possible</>
        )}
      </Button>

      <AvoidLimitUpgradeModal open={showUpgradeModal} onClose={() => setShowUpgradeModal(false)} />
    </>
  )
}

export default AvoidUser
